import { isAgentVersionSufficientForEvictor } from '@cast/split-me/utils/cluster';
import { PRESET_TYPES, PRESET_VALUES } from '../_constants';
import { FormValues, PresetType } from '../_types';
import { ClusterStatus, AgentStatus } from '@cast/types';
import { EvictorConfig } from '@cast/types-workload-eviction';

export const derivePreset = (formValues: FormValues): PresetType => {
  return PRESET_TYPES.reduce<PresetType>((derivedPreset, presetType) => {
    if (presetType === 'custom') {
      return derivedPreset;
    }

    const presetValues = PRESET_VALUES[presetType];
    if (
      formValues.cycleIntervalSeconds === presetValues.cycleIntervalSeconds &&
      formValues.nodeGracePeriodMinutes ===
        presetValues.nodeGracePeriodMinutes &&
      formValues.scopedMode === presetValues.scopedMode &&
      formValues.maxTargetNodesPerCycle ===
        presetValues.maxTargetNodesPerCycle &&
      formValues.aggressiveMode === presetValues.aggressiveMode
    ) {
      return presetType;
    }

    return derivedPreset;
  }, 'custom');
};

type IsEvictorConfigurableInput = {
  evictorConfig: EvictorConfig;
  clusterAgentVersion: string | undefined;
  hasEvictorUpdatePermission: boolean;
  clusterStatus: ClusterStatus;
  agentStatus: AgentStatus;
  isClusterManaged: boolean;
  isWoopInstalled: boolean;
};

export const isEvictorConfigurable = ({
  evictorConfig,
  clusterAgentVersion,
  hasEvictorUpdatePermission,
  clusterStatus,
  agentStatus,
  isClusterManaged,
  isWoopInstalled,
}: IsEvictorConfigurableInput): boolean => {
  const isClusterReady =
    clusterStatus === ClusterStatus.READY ||
    clusterStatus === ClusterStatus.WARNING ||
    clusterStatus === ClusterStatus.READ_ONLY;

  const isAgentDisconnected = agentStatus === AgentStatus.DISCONNECTED;
  const isWoopOnlyCluster = !isClusterManaged && isWoopInstalled;
  // WOOP-only clusters don't need cloud credentials — evictor doesn't call cloud APIs
  const credentialsRequired = !isWoopOnlyCluster;

  const isEvictorReady =
    evictorConfig.status !== 'EVICTOR_STATUS_INCOMPATIBLE' &&
    evictorConfig.status !== 'EVICTOR_STATUS_MISSING' &&
    !!clusterAgentVersion &&
    isAgentVersionSufficientForEvictor(clusterAgentVersion);

  return (
    isEvictorReady &&
    !isAgentDisconnected &&
    hasEvictorUpdatePermission &&
    isClusterReady &&
    (!credentialsRequired || isClusterManaged)
  );
};
